import React from "react";
import { Link } from "react-router-dom";

import { CatechesisCard, SectionHeading } from "../components";

const CatechesisGrid = ({
  section,
  columns,
  searchQuery,
  onToggleFavorite,
}) => {
  const { heading, items } = section;

  const gridColumnsClass = columns
    ? `grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-${columns || 4} gap-4`
    : "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4";

  const filteredItems = searchQuery
    ? items.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : items;

  return (
    <div className="py-8">
      {heading && (
        <SectionHeading
          title={heading.title}
          icon={heading.icon}
          link={heading.link}
          linkTitle={heading.linkTitle}
          classes="mb-4"
        />
      )}
      <div className={`grid grid-cols-1 ${gridColumnsClass}`}>
        {filteredItems.length > 0 ? (
          filteredItems.map((item, index) => (
            <div key={index}>
              <CatechesisCard {...item} slug={item.slug} onToggleFavorite={onToggleFavorite} />
            </div>
          ))
        ) : (
          // Show message if no results found
          <div className="py-6 text-center text-gray-500 col-span-full">
            No catechesis found for "{searchQuery}"
          </div>
        )}
      </div>
    </div>
  );
};

export default CatechesisGrid;
